<template>
    <div class="content">
        <div class="fwb_content" v-if="arrItem.content">
            <div class="title">{{ arrItem.title }}</div>
            <div class="light">
                {{ arrItem.type | typeText }}
                <div class="look">

                    {{ arrItem.view_num }}
                </div>
            </div>
            <div class="sHtml" v-html="arrItem.content"></div>
        </div>
        <!-- 视频 -->
        <div class="type1" v-if="arrItem.video">
            <div class="title">{{ arrItem.title }}</div>
            <div class="video">
                <video :id="arrItem.id" controls="controls" :poster="arrItem.thumb" :src="arrItem.video" loop="loop" preload="auto" x5-video-player-type="h5" playsinline="true" webkit-playsinline="true" x-webkit-airplay="true" x5-video-orientation="portraint" x5-video-player-fullscreen="true"></video>
                <!-- <div class="icon-play" v-if="arrItem.bPlay" @click.stop="play(arrItem.id, index)"></div> -->
            </div>
        </div>
        <!-- PDF -->
        <div class="type1" v-if="arrItem.pdf.length">
            <div class="pdfImg" v-for="(item, index) in arrPreviewUrl" :key="index" @click="openLook(index)">
                <img class="imgUrl" v-lazy="item" alt="" />
            </div>
            <div @click="getBtn" class="btn" v-if="arrItem.is_can_download">
                下载pdf
            </div>
        </div>
        <!-- loading -->
        <loading :bLoading="bLoading" :nLoading="nLoading"></loading>
        <!-- 预览图片 -->
        <van-image-preview v-model="show" :startPosition="lookImgIndex" :images="images" @change="lookChang">
            <template v-slot:imgIndex>第{{ imgIndex }}页</template>
        </van-image-preview>
    </div>
</template>
<script>
import loading from "@/components/cms/loading/index.vue";
import { getWxSingleConfig } from "@/js/wx.js";
import oDetail from "@/js/detail.js";
export default {
    components: {
        loading,
    },
    data() {
        return {
            show: false,
            imgIndex: 0,
            lookImgIndex: 0,
            images: [],
            bLoading: false,
            nLoading: 0,
            arrItem: {
                content: "",
                pdf: [],
            },
            pdfUrl: "",
            arrPreviewUrl: [],
            progressTime: "",
        };
    },
    created() {
        this.$store.commit("loadSwitch", true);
        $init(() => {
            window.addEventListener("pageshow", this.setNav);
            oDetail.getCmsDetail({ id: this.$route.query.id }).then((res) => {
                let contentObj = res.result;
                let confit = {
                    share_friend_title: `请查阅您的艾暖通消息`,
                    share_friend_desc: contentObj.title,
                    share_img_url:
                        "https://aotest-lottery.iwxapi.com/core/images2020/watersystem/ant/share_img.png",
                    share_link: `${window.location.protocol}//${window.location.host}${window.location.pathname}?id=${this.$route.query.id}`,
                };
                getWxSingleConfig(confit);
                if (contentObj.is_can_share == 0 && contentObj.type == 4) {
                    wx.ready(() => {
                        wx.hideOptionMenu();
                    });
                }
                if (contentObj.type == 2) {
                    contentObj.content = contentObj.content.replace(
                        /\<img/gi,
                        '<img style="width:100%;height:auto;"'
                    );
                }
                if (contentObj.type == 4) {
                    this.bLoading = true;
                    document.title = contentObj.title;
                    if (contentObj.pdf.length) {
                        this.progressTime = setInterval(() => {
                            let nNum = Math.floor(
                                Math.random() * (2 - 1 + 1) + 1
                            );
                            this.nLoading += nNum;
                            if (this.nLoading >= 99) {
                                this.nLoading = 99;
                            }
                        }, 1500);
                        oDetail
                            .getPdfPath({
                                id: contentObj.pdf[0].id,
                                client_type: this.isIPhoneX(),
                            })
                            .then((res) => {
                                let pdfUrl = res.result;
                                this.pdfUrl = pdfUrl;
                                this.arrPreviewUrl = pdfUrl.preview_image_url;
                                pdfUrl.preview_image_url.forEach((it) => {
                                    this.images.push(it);
                                });
                                this.nLoading = 100;
                                clearInterval(this.progressTime);
                                setTimeout(() => {
                                    this.bLoading = false;
                                    if (!this.arrPreviewUrl.length) {
                                        this.$toast("PDF加载中，请稍后重试~");
                                        return false;
                                    }
                                    this.$previewRefresh(); //执行查看图片方法
                                }, 500);
                            });
                    } else {
                        this.$toast("请上传PDF");
                    }
                }
                this.arrItem = contentObj;
                this.$store.commit("loadSwitch", false);
            });
        });
    },
    beforeDestroy() {
        window.removeEventListener("pageshow", this.setNav);
    },
    filters: {
        typeText(type) {
            switch (type) {
                case 1:
                    return "视频";
                    break;
                case 2:
                    return "图文";
                    break;
                case 3:
                    return "混合";
                    break;
                case 4:
                    return "PDF";
                    break;
            }
        },
    },
    methods: {
        openLook(index) {
            this.show = true;
            this.lookImgIndex = index;
        },
        lookChang(index) {
            this.imgIndex = index;
        },
        setNav() {
            $init(() => {
                let confit = {
                    share_friend_title: `请查阅您的艾暖通消息`,
                    share_friend_desc: this.arrItem.title,
                    share_img_url:
                        "https://aotest-lottery.iwxapi.com/core/images2020/watersystem/ant/share_img.png",
                    share_link: `${window.location.protocol}//${window.location.host}${window.location.pathname}?id=${this.$route.query.id}`,
                };
                getWxSingleConfig(confit);
                if (this.arrItem.is_can_share == 0 && this.arrItem.type == 4) {
                    wx.ready(() => {
                        wx.hideOptionMenu();
                    });
                }
            });
        },
        isIPhoneX() {
            var u = navigator.userAgent;
            var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
            var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
            if (isiOS) {
                return 0;
            } else if (isAndroid) {
                return 1;
            }
        },
        look(id) {
            this.$router.push({ path: `/cms/preview?id=${id}` });
        },
        play(idx) {
            var newVis = document.getElementById(idx);
            newVis.play();
            this.arrItem.bPlay = false;
        },
        getBtn() {
            window.location.href = this.arrItem.pdf[0].file;
        },
    },
};
</script>
<style lang="scss" scoped>
::v-deep .van-image__img {
    pointer-events: none !important;
}
.hhhh{
    width: 500px;
    height: 500px;
    background: #000;
}
.content {
    width: 100%;
    min-height: 100vh;
    padding: 0 10px;
    box-sizing: border-box;
    .ifrema_tips {
        position: fixed;
        z-index: 9;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
        background: rgba($color: #000000, $alpha: 0.7);
        .if_content {
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            margin: auto;
            transform: scale(0.9);
            background: #fff;
            iframe {
                width: 100%;
                height: 100%;
            }
        }
    }
    .pdfList {
        width: 100%;
        padding: 0 20px;
        box-sizing: border-box;
        .item {
            padding: 26px 20px;
            width: 100%;
            border: 1px solid rgb(44, 122, 236);
            display: flex;
            align-items: center;
            justify-content: space-between;
            border-radius: 10px;
            .item_title {
                font-size: 32px;
                font-weight: 700;
            }
            .item_btn {
                padding: 5px 10px;
                box-sizing: border-box;
                border: 1px solid rgb(44, 122, 236);
                color: rgb(44, 122, 236);
            }
        }
    }
    .fwb_content {
        width: 100%;
        .title {
            width: 100%;
            font-size: 40px;
            text-align: center;
            // font-weight: 700;
            padding: 30px 0 0;
            margin-bottom: 30px;
            box-sizing: border-box;
        }
        .sHtml {
            width: 100%;
        }
    }
    .light {
        color: #999;
        padding-right: 20px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin-bottom: 30px;
        .look {
            display: flex;
            align-items: center;
            margin-left: 10px;
            &::before {
                content: "";
                display: inline-block;
                height: 24px;
                width: 34px;
                background: url(~@/assets/images/antV2/scheme/chakan.png)
                    no-repeat center/100% 100%;
            }
        }
    }
    .type1 {
        width: 100%;
        height: 100vh;
        .pdfImg {
            width: 100%;
            position: relative;
            .imgUrl {
                width: 100%;
                border: 2px solid #f5f5f5;
                pointer-events: none !important;
            }
            .lookUrl {
                position: absolute;
                width: 100%;
                z-index: 1;
                opacity: 0;
                left: 0;
                top: 0;
            }
        }
        iframe {
            width: 100%;
            height: 100%;
        }
        .btn {
            width: 180px;
            height: 80px;
            border-radius: 10px;
            background: rgb(44, 122, 236);
            color: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 28px;
            position: fixed;
            z-index: 99;
            bottom: 30px;
            right: 20px;
        }
        // margin-top: 10px;
        .title {
            width: 100%;
            font-size: 30px;
            padding: 10px;
            box-sizing: border-box;
        }
        .video {
            position: relative;
            width: 100%;
            height: 400px;
            background: #000;
            video {
                width: 100%;
                height: 100%;
                display: block;
                object-fit: fill;
            }
            .icon-play {
                position: absolute;
                left: 0;
                right: 0;
                top: 50%;
                margin: 0 auto;
                background: url(../../assets/images/play_icon.png) no-repeat;
                background-size: 90px 90px;
                width: 90px;
                height: 90px;
                margin-top: -45px;
            }
        }
        .tips {
            font-size: 26px;
            margin: 20px 0;
        }
    }
}
</style>
